import React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

const TitanIntroText = ({ content }) => {
  if (!content) {
    return null;
  }

  return <Wrapper><ReactMarkdown>{content}</ReactMarkdown></Wrapper>;
};

const Wrapper = styled.div`
  p {
    color: #fff;
    text-align: center;

    strong {
      color: #ff8f00;
    }
  }
`;

export default TitanIntroText;
